module.exports = __webpack_public_path__ + "img/filter-close.779be322.svg";